export enum BlockPreviewOptions {
    All = 'All',
    None = 'None',
}
interface Environment {
    environmentUri: string;
    description?: string;
    created: string;
    label: string;
    userRoleInEnvironment: string;
    originSamlGroupName: string[];
    originSamlFullDevGroupName: string[];
    originSamlBasicDevGroupName?: string[];
    originSamlReaderGroupName: string[];
    identityProviderName?: string;
    blockpreview?: BlockPreviewOptions;
    stack: {
        status: string;
    };
    quicksight_enabled?: boolean;
    role_overwrite_enabled?: boolean;
}

interface NewEnvironmentInput {
    label: string;
    organizationUri: string;
    SamlGroupName: string[];
    SamlFullDevGroupName: string[];
    SamlBasicDevGroupName: string[];
    SamlReaderGroupName: string[];
    tags: string[];
    description: string;
    AwsProdAccountId: string;
    AwsDevAccountId: string;
    AwsTestAccountId: string;
    AwsToolAccountId: string;
    AwsValAccountId: string;
    region: string;
    blockpreview: string;
    bucketVersioning?: string;
    quicksight_enabled: boolean;
    sagemaker_studio_enabled?: boolean;
    defaultPipelineVpcId: string;
    identityProviderName: string;
}

interface ModifyEnvironmentInput {
    description?: string;
    tags?: string[];
    SamlGroupName: string[];
    SamlFullDevGroupName: string[];
    SamlBasicDevGroupName?: string[];
    SamlReaderGroupName: string[];
    blockpreview?: BlockPreviewOptions;
    bucketVersioning?: string;
    quicksight_enabled?: boolean;
    role_overwrite_enabled?: boolean;
    sagemaker_studio_enabled?: boolean;
    defaultPipelineVpcId?: string;
    AwsDevAccountId?: string;
    AwsTestAccountId?: string;
    AwsToolAccountId?: string;
    AwsValAccountId?: string;
    identityProviderName?: string;
}

interface EnvironmentListItem {
    label: string;
    description: string;
    created: string;
    updated?: string;
    environmentUri: string;
    organization: {
        label: string;
        organizationUri: string;
    };
    stack: {
        status: string;
    };
}

interface EnvironmentSelectItem {
    value: string;
    key: string;
    label: string;
    organizationUri: string;
}

interface EnvironmentListResult {
    nodes: EnvironmentListItem[];
    count: number;
    page: number;
    pages: number;
}

// Sagemaker interfaces
interface UserProfilesMessage {
    username: string;
    group: string;
    role: string;
    actions?: React.JSX.Element;
    deleteLoading?: boolean;
    urlLoading?: boolean;
}

interface UserProfilesResponse {
    data: {
        message: UserProfilesMessage[];
        status: string;
    };
}

interface NewSagemakerUserProfileInput {
    environmentUri: string;
    group: string;
    role: string;
    userProfileParamsJson?: string;
}

interface DeleteSagemakerUserProfileInput {
    environmentUri: string;
    group: string;
    role: string;
}

export enum EnvironmentStage {
    PROD = 'Prod',
    DEV = 'Dev',
    VAL = 'Val',
    TEST = 'Test',
    TOOL = 'Tool',
}

export type {
    Environment,
    EnvironmentListItem,
    EnvironmentListResult,
    EnvironmentSelectItem,
    UserProfilesMessage,
    UserProfilesResponse,
    NewSagemakerUserProfileInput,
    DeleteSagemakerUserProfileInput,
    NewEnvironmentInput,
    ModifyEnvironmentInput,
};
